import { render, staticRenderFns } from "./RequestEntityDetails.vue?vue&type=template&id=33f63a80&scoped=true"
import script from "./RequestEntityDetails.vue?vue&type=script&lang=js"
export * from "./RequestEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./RequestEntityDetails.vue?vue&type=style&index=0&id=33f63a80&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f63a80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33f63a80')) {
      api.createRecord('33f63a80', component.options)
    } else {
      api.reload('33f63a80', component.options)
    }
    module.hot.accept("./RequestEntityDetails.vue?vue&type=template&id=33f63a80&scoped=true", function () {
      api.rerender('33f63a80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RequestEntityDetails.vue"
export default component.exports